import {IImportService} from "./IImportService";
import {BaseService} from "./BaseService";
import {ClientApp} from '../entities/ClientApp'
import { StateService } from "@uirouter/angularjs";

export class ClientAppService extends BaseService<ClientApp>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, ClientApp);
    }
    protected getBaseUrl():string{
        return "clientapp";
    }

    generateSecret():ng.IPromise<string> {
        var config:any = {};
        return this.useGetHandler(this.getBaseUrl(),"clientSecret", config);
    }
}
